<div class="p-1">
  <h2 mat-dialog-title class="text-base font-semibold">Delete Inspection Report</h2>

  <mat-dialog-content class="mt-2">
    <p class="text-sm text-gray-600">
      Are you sure you want to delete this draft report?
    </p>
    <p class="text-xs text-gray-400 mt-1">
      {{ data.reportDate | date:'dd MMM yyyy HH:mm' }}
    </p>
    <p class="text-xs text-red-500 mt-3">This action cannot be undone.</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="gap-2 mt-2">
    <button mat-stroked-button
            (click)="cancel()"
            style="color: rgba(0,0,0,0.87); border-color: rgba(0,0,0,0.2); background: transparent;">
      Cancel
    </button>
    <button mat-flat-button color="warn" (click)="confirm()">Delete</button>
  </mat-dialog-actions>
</div>
